<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card">

        
        <h4>List of Task & Event Results</h4>
        
        <div class="p-mb-4 p-d-flex p-jc-between p-toolbar">
          <Button
            label="New Result"
            icon="pi pi-plus"
            class="p-button-success p-mr-2"
            style="margin-right: 1em"
            @click="openNew"
          />
          <div>
            <span class="p-input-icon-left">
              <i class="pi pi-search" />
              <InputText
                v-model="filters"
                placeholder="Global Search"
                style="margin-right: 0.5em"
                @input="updateSearch"
              />
            </span>
          </div>
        </div>

        <ActivityResultsTable
          :key="activityResutlsKey"
          :activityResults="activityResults"
          :loading="loading"
          @edit-activity-result="editActivityResult"
        />

        <ActivityResultsForm
          :activityResultToEdit="activityResult"
          :key="activityResultFormKey"
          :activityResultForm="activityResultForm"
          :disabledArr="disabledArr"
          @close="hideActivityResultDialog"
          @save="saveActivityResult"
        />

      </div>
    </div>
  </div>
</template>

<script>
import ActivityService from "@/service/ActivityService";

import ActivityResultsTable from './activityResultsTable'
import ActivityResultsForm from './activityResultForm'

export default {
  components: {
    ActivityResultsTable,
    ActivityResultsForm
  },
  data: () => ({
    activityService: new ActivityService(),
    filters: '',
    activityResutlsKey1: 0,
    activityResults: [],
    activityResultForm: false,
    activityResultFormKey1: 0,
    disabledArr: [],
    activityResult: {},
    requesting: false
  }),
  computed: {
    activityResutlsKey: {
      set(val) {
        this.activityResutlsKey1++
      },
      get() {
        return 'ActivityResultsTable' + this.activityResutlsKey1.toString()
      }
    },
    activityResultFormKey: {
      set(val) {
        this.activityResultFormKey1++
      },
      get() {
        return 'ActivityResultForm' + this.activityResultFormKey1.toString()
      }
    },
    loading() {
      if (this.activityResults && this.activityResults[0]) {
        return false
      } else {
        if (this.requesting) {
          return true
        } else {
          return false
        }
      }
    }
  },
  created() {
    this.getAllActivityResults()
    if (this.$route.query.search !== '') {
      this.updateSearch('')
    }
  },
  watch: {
    filters(val) {
      this.activityResutlsKey++
    },
    activityResultForm(val) {
      this.activityResultFormKey++
    },
    activityResults(val) {
      if (val && Array.isArray(val)) {
        this.activityResutlsKey++
      }
    }
  },
  methods: {
    editActivityResult(activityResult) {
      this.activityResult = activityResult
      this.activityResultForm = true
    },
    saveActivityResult(activityResult) {
      

      if (activityResult.id) {
        delete activityResult.createActDesc
        delete activityResult.createActType
        delete activityResult.createActivity
        delete activityResult.colourCode
        delete activityResult.daysFromNow

        this.activityService
          .editActivityResult(activityResult)
          .then(data => {
            this.$toast.add({
              severity: "success",
              summary: "Result updated",
              detail: "Result updated successfully.",
              life: 5000,
            });
          
            this.activityResultForm = false
            this.getAllActivityResults()
            this.getAllActiveActivityResultsByHard()
          })
          .catch(err => {
            
                  
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while updating the result",
              life: 5000,
            })
          })
      } else {
        this.activityService
          .saveActivityResult(activityResult)
          .then(data => {
            this.$toast.add({
              severity: "success",
              summary: "Result saved",
              detail: "Result saved successfully.",
              life: 5000,
            })
          
            this.activityResultForm = false
            this.getAllActivityResults()
            this.getAllActiveActivityResultsByHard()
          })
          .catch(err => {
            
                  
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while saving the result",
              life: 5000,
            })
          })
      }
    },
    hideActivityResultDialog() {
      this.activityResult = {}
      this.activityResultForm = false
    },
    getAllActivityResults() {
      this.requesting = true
      this.activityService
        .getAllActivityResultsByHard()
        .then(data => {
          this.requesting = false
          this.activityResults = data
        })
        .catch(err => {
          this.requesting = false
          
          
                
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting activity results",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "activityResults"'
          })
        })
    },
    getAllActiveActivityResultsByHard() {
      this.activityService
        .getAllActiveActivityResultsByHard()
        .then(data => {})
        .catch(err => {
          

          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "activeactivityresults"'
          })
        })
    },
    updateSearch(e) {
      this.$router.push({ query: { search: e } });
    },
    openNew() {
      this.activityResult = {}
      this.activityResultForm = true
    }
  }
}
</script>

<style>

</style>